/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import router from "@/router";
export default /*@__PURE__*/_defineComponent({
  __name: 'Tabbar',
  props: {
    active: {
      type: Number,
      default: () => 0
    }
  },
  setup(__props) {
    const prop = __props;
    const activeIndex = ref(prop.active);
    watch(() => prop.active, newVal => {
      activeIndex.value = newVal;
    });
    const onChange = index => {
      activeIndex.value = index;
      if (index == 0) {
        router.push({
          path: "/"
        });
      } else {
        router.push({
          path: "/stat"
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      return _openBlock(), _createBlock(_component_van_tabbar, {
        modelValue: _unref(activeIndex),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(activeIndex) ? activeIndex.value = $event : null),
        onChange: onChange
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          icon: "home-o"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("首页")])),
          _: 1,
          __: [1]
        }), _createVNode(_component_van_tabbar_item, {
          icon: "bar-chart-o"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("统计")])),
          _: 1,
          __: [2]
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});